<script>
export default {
    name: "CareersMobileBtn"
}
</script>
<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="114.504" height="28.886" viewBox="0 0 114.504 28.886">
        <g id="Group_929" data-name="Group 929" transform="translate(39)">
            <text class="stMobileBtnCareers0" id="apply_now" data-name="apply now" transform="translate(-39 16.815)"  font-size="10" font-family="Apertura-Medium, Apertura" font-weight="500" letter-spacing="0.1em"><tspan x="0" y="0">apply now</tspan></text>
            <path class="stMobileBtnCareers1" id="Path_1078" data-name="Path 1078" d="M0,11.888,11.888,0,23.775,11.888" transform="translate(64.79 2.513) rotate(90)" fill="none" stroke-width="1"/>
            <g class="stMobileBtnCareers1" id="Ellipse_52" data-name="Ellipse 52" transform="translate(46.618)" fill="none"  stroke-width="1">
                <ellipse cx="14.443" cy="14.443" rx="14.443" ry="14.443" stroke="none"/>
                <ellipse cx="14.443" cy="14.443" rx="13.943" ry="13.943" fill="none"/>
            </g>
            <path class="stMobileBtnCareers1" id="Path_1079" data-name="Path 1079" d="M9213.073,2406h-40.562" transform="translate(-9148.253 -2391.557)" fill="none"  stroke-width="1"/>
        </g>
    </svg>
</template>
<style lang="css" scoped>
.stMobileBtnCareers0{fill:#FFFFFF;}
.stMobileBtnCareers1{stroke:#FFFFFF;}
</style>
